/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'account': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M212.195 284.444A284.444 284.444 0 10496.64 0a284.444 284.444 0 00-284.445 284.444zM699.449 662.3H324.38c-163.043 0-295.14 73.387-295.14 164.352v197.462h965.405V826.766C994.873 735.972 861.98 662.3 699.449 662.3z"/>'
  }
})
